import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { hasImobClubAccess } from '@shared/utils/imob-club-access.util';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { MeuUsuarioService } from 'src/app/features/perfil/services/meu-usuario.service';

/**
 * Restringe o acesso ao ImobClub (Imob Negócios) a quem participa de alguma turma
 * (aluno do treinamento Smart — regra do antigo Mapa dos Smartanos) OU tem a role
 * `IMOB_NEGOCIOS` ativa.
 *
 * Lê o usuário do store; se ainda não estiver carregado — caso típico de navegação direta
 * pela URL, já que o store só é populado pelo header após a ativação da rota — busca via
 * `getUserData()` para evitar deadlock esperando por um usuário que nunca chega.
 */
@Injectable({ providedIn: 'root' })
export class TurmaGuard {
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly meuUsuarioService = inject(MeuUsuarioService);

  canActivate(): Observable<boolean | UrlTree> {
    return this.store.select(selectUser).pipe(
      take(1),
      switchMap((user) => (user ? of(user) : this.meuUsuarioService.getUserData())),
      map((user) =>
        hasImobClubAccess(user) ? true : this.router.createUrlTree(['home']),
      ),
      catchError(() => of(this.router.createUrlTree(['home']))),
    );
  }
}
